import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from "@angular/material";

import { PujaPrasadMaster } from "./../puja-prasad-master";
import { PayUMoneyPayment } from "./../pay-u-money-payment";
import { PujaPrasadService } from "./../puja-prasad.service";
import { PujaPrasadOrderService } from "./../puja-prasad-order.service";
import { SharedService } from "./../../shared/shared.service";
import { AddressConfirmDialogComponent } from "./../address-confirm-dialog/address-confirm-dialog.component";
import { stringify } from '@angular/core/src/util';
import { PujaVidhi } from '../puja-vidhi';
import { RazorpayService } from '../razorpay.service';
import { DevoteeDetail } from '../../Devotee/devotee-detail';
import { PujaPrasadOrderResponse } from '../puja-prasad-order-response';
import { PujaPrasadOrder } from '../puja-prasad-order';


@Component({
  selector: 'app-puja-prasad-order',
  templateUrl: './puja-prasad-order.component.html',
  styleUrls: ['./puja-prasad-order.component.css'],
  providers: [PujaPrasadService, PujaPrasadOrderService]
})
export class PujaPrasadOrderComponent implements OnInit {

  constructor(private activeRoute: ActivatedRoute,
    private router: Router,
    private formBuilder: FormBuilder,
    private sharedService: SharedService,
    private pujaPrasadService: PujaPrasadService,
    private pujaPrasadOrderService: PujaPrasadOrderService,
    private razorpayService: RazorpayService,
    private dialog: MatDialog) { }

  prasadOrderForm: FormGroup;
  pujaPrasadId: number;
  pujaPrasadDetail: PujaPrasadMaster;
  devoteeDetail: DevoteeDetail;
  payUMoneyPayment: PayUMoneyPayment;
  successMessage: string;
  errorMessage: string;
  validationMessage: string = '';
  showPaymentBtn: boolean = true;
  pujaVidhis: PujaVidhi[] = [];
  pujaVidhiErrors: string[] = [];
  totalCartAmount: number = 0;

  ngOnInit() {
    this.createPrasadOrderForm();
    this.devoteeDetail = this.sharedService.getDevoteeDataAtLocStorage();
    this.loadPujaVidhis();

    this.payUMoneyPayment = new PayUMoneyPayment();

    if (this.devoteeDetail.FirstName == null || this.devoteeDetail.LastName == null
      || this.devoteeDetail.FirstName.trim() + this.devoteeDetail.LastName.trim() === ''){
        alert("Please update your profile before placing order");
        this.router.navigate(["/devoteeprofile"]);
      }
      


    //this.activeRoute.params.subscribe(params => this.loadPujaPrasadDetail(params.id))
    //console.log(this.pujaPrasadDetail);
  }

  private loadPujaVidhis() {
    var devoteeCarts = this.sharedService.getDevoteeCartDataAtLocStorage();

    this.pujaVidhis = [];
    devoteeCarts.forEach(element => {
      var pujaVidhi = new PujaVidhi();
      pujaVidhi.PujaVidhiId = element.PujaVidhiNo;
      pujaVidhi.PujaVidhiName = element.TypeOfPuja;
      pujaVidhi.Cost = element.Amount;
      this.pujaVidhis.push(pujaVidhi);
    });

    this.calculateTotalCartAmount();
  }

  removeFromCart(pujaVidhi: PujaVidhi) {
    var devoteeCarts = this.sharedService.getDevoteeCartDataAtLocStorage();
    devoteeCarts = devoteeCarts.filter(x => x.PujaVidhiNo != pujaVidhi.PujaVidhiId);
    this.sharedService.setDevoteeCartDataAtLocStorage(devoteeCarts);
    this.loadPujaVidhis();
  }

  public calculateTotalCartAmount() {
    let totalAmount = 0;
    this.pujaVidhis.forEach(x => totalAmount += x.Cost);
    this.totalCartAmount = totalAmount;
  }


  // private loadPujaPrasadDetail(id: number) {
  //   this.sharedService.showSpinner();
  //   this.pujaPrasadService.getPujaDetailById(id).subscribe(
  //     data => {
  //       this.pujaPrasadDetail = data;
  //       console.log(this.pujaPrasadDetail);
  //     },

  //     err => {
  //       console.log(err);
  //       this.sharedService.hideSpinner();
  //     },
  //     () => this.sharedService.hideSpinner()
  //   )
  // }

  openAddressVerification(): void {
    if (this.prasadOrderForm.invalid) {
      this.sharedService.validateAllFormFields(this.prasadOrderForm);

      if (this.prasadOrderForm.controls.OnBehalfOf.errors
        && this.prasadOrderForm.controls.OnBehalfOf.errors.required) {
        this.validationMessage = "Please Enter Perform Puja on Behalf";
      }
      console.log(this.prasadOrderForm.errors);
      return;
    }

    if (!this.validatePujaVidhi()) {
      return;
    }

    this.validationMessage = '';

    let matDialogRef = this.dialog.open(AddressConfirmDialogComponent, { disableClose: false, width: '500px' });

    matDialogRef.afterClosed().subscribe(
      data => {
        console.log(data);
        if (data != "Confirm") {
          return;
        }

        this.placeOrder();
      }
    )
  }

  private validatePujaVidhi() {
    this.pujaVidhiErrors = [];
    if (this.pujaVidhis.length == 0) {
      this.pujaVidhiErrors.push("Please add Puja Prasad to cart");
      return false;
    }

    // validate all puja vidhi has vidhi date
    for (let i = 0; i < this.pujaVidhis.length; i++) {
      if (this.pujaVidhis[i].VidhiDate == null) {
        this.pujaVidhiErrors.push("Please select Puja Vidhi Date for Puja: " + this.pujaVidhis[i].PujaVidhiName);
      }
    }

    if (this.pujaVidhiErrors.length > 0) {
      return false;
    }

    return true;
  }

  // private loadPaymentbyTransId(transId: string) {
  //   this.sharedService.showSpinner();
  //   this.pujaPrasadOrderService.getPayUMoneyPaymentByTransId(transId).subscribe(
  //     data => {
  //       this.prasadOrderForm.controls.OnBehalfOf.setValue(data.PerformPujaOnBehalf);
  //       this.prasadOrderForm.controls.PujaTithi.setValue(data.PujaTithi);
  //       this.prasadOrderForm.controls.YourWish.setValue(data.YourWish);
  //       this.prasadOrderForm.controls.OnWhichDate.setValue(data.PujaDate);
  //       this.prasadOrderForm.controls.PaymentMode.setValue(data.PaymentMode);

  //       if (data.Status == "success") {
  //         this.prasadOrderForm.markAsPristine();
  //         this.successMessage = "Your Puja Prasad Order placed successfully, With prasad order number : " + data.PrasadOrderId;
  //         this.showPaymentBtn = false;
  //       }
  //     },

  //     err => {
  //       console.log(err);
  //       this.sharedService.hideSpinner();
  //     },
  //     () => this.sharedService.hideSpinner()
  //   )
  // }

  placeOrder(): void {

    if (this.prasadOrderForm.invalid) {
      this.sharedService.validateAllFormFields(this.prasadOrderForm);
      console.log(this.prasadOrderForm.errors);
      return;
    }

    if (!this.validatePujaVidhi()) {
      return;
    }

    this.validationMessage = '';


    var pujaPrasadOrder: PujaPrasadOrder = {
      MobileNo: this.devoteeDetail.MobileNo.toString(),
      Name: this.devoteeDetail.FirstName,
      Gotra: this.prasadOrderForm.controls.Gotra.value,
      PrasadQuantity: 1,
      WishTextData: this.prasadOrderForm.controls.YourWish.value,
      TotalCost: this.totalCartAmount,
      PujaVidhis: this.pujaVidhis,
      PaymentRemark: "Online Payment",
      Platform: "DevoteeWebApp"
    }

    this.sharedService.showSpinner();
    this.pujaPrasadOrderService.save(pujaPrasadOrder).subscribe(
      data => {
        this.prasadOrderForm.markAsPristine();
        //this.successMessage = data;
        this.sharedService.setDevoteeCartDataAtLocStorage([]);
        this.makePayment(data);
        //this.router.navigate(['pujaprasadseva', 'PaytmSuccess']);
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  makePayment(pujaPrasadOrderResponse: PujaPrasadOrderResponse) {
    this.razorpayService.initializePayment(
      pujaPrasadOrderResponse.PaymentOrderId, // Order ID
      pujaPrasadOrderResponse.Amount, // Payment amount
      'INR', // Currency
      'Puja Prasad', // Name
      'Payment for Puja Prasad', // Description
      {
        name: this.devoteeDetail.FirstName, // Prefill Name
        email: this.devoteeDetail.Email, // Prefill Email
        contact: this.devoteeDetail.MobileNo, // Prefill Contact Number
      },
      (response) => {
        console.log('Payment successful!', response);        
        window.location.href = '/#/mypujaprasadorder/razorpaySuccess';        
      },
      (response) => {
        console.log('Payment Failed!', response);
        window.location.href = '/#/mypujaprasadorder/razorpayFalied';
      },
      () => {
        console.log('Payment close by user!');
        window.location.href = '/#/mypujaprasadorder/razorpayClosed';
      }
      
    );
  }


  createPrasadOrderForm(): void {
    this.prasadOrderForm = this.formBuilder.group({
      OnBehalfOf: [, Validators.required],
      YourWish: [],
      Gotra: [],
      PaymentMode: ["PayUMoney"]
    });
  }


  pujaTithies: string[] = [
    "Pratipada",
    "Dwitiya",
    "Tritiya",
    "Chaturthi",
    "Panchami",
    "Shashthi",
    "Saptami",
    "Ashtami",
    "Navami",
    "Dashami",
    "Dwadashi",
    "Trayodashi",
    "Chaturdashi",
    "Purnima"
  ]




  payment() {

    if (this.prasadOrderForm.invalid) {
      this.sharedService.validateAllFormFields(this.prasadOrderForm);
      console.log(this.prasadOrderForm.errors);
      return;
    }



    this.payUMoneyPayment.PerformPujaOnBehalf = this.prasadOrderForm.controls.OnBehalfOf.value;
    this.payUMoneyPayment.PujaTithi = this.prasadOrderForm.controls.PujaTithi.value;
    this.payUMoneyPayment.YourWish = this.prasadOrderForm.controls.YourWish.value;
    this.payUMoneyPayment.PujaDate = this.prasadOrderForm.controls.OnWhichDate.value;
    this.payUMoneyPayment.PujaId = this.pujaPrasadDetail.Id;


    this.payUMoneyPayment.FirstName = this.devoteeDetail.FirstName;
    this.payUMoneyPayment.Amount = this.pujaPrasadDetail.Amount.toString();
    this.payUMoneyPayment.Email = this.devoteeDetail.Email ? this.devoteeDetail.Email : '';
    this.payUMoneyPayment.Phone = this.devoteeDetail.MobileNo.toString();
    this.payUMoneyPayment.MobileNo = this.devoteeDetail.MobileNo.toString();
    this.payUMoneyPayment.ProductInfo = "PrasadOrder";

    this.sharedService.showSpinner();
    this.pujaPrasadOrderService.getPayUMoneyPayment(this.payUMoneyPayment).subscribe(
      data => {
        if (data != null) {
          let url = SharedService.BaseServiceUrl + "PayUMoney/PayUMoneyPost";
          let options = {
            "FirstName": data.FirstName,
            "Amount": data.Amount,
            "productinfo": data.ProductInfo,
            "Email": data.Email,
            "phone": data.Phone,
            "key": data.Key,
            "txnid": data.TxnId,
            "hash": data.Hash,
            "surl": url,// + "/PayUMoneySuccessPost",
            "furl": url,// + "/PayUMoneyFailurePost",
            "service_provider": "payu_paisa"
          };

          console.log(options);
          //this.post("https://sandboxsecure.payu.in/_payment", options, "post");
          this.post("https://secure.payu.in/_payment", options, "post");
        }
      },
      err => {
        console.log(err);
        this.sharedService.hideSpinner();
      },
      () => this.sharedService.hideSpinner()
    )
  }

  post(path: string, params: any, method: string) {
    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);
    for (var key in params) {
      if (params.hasOwnProperty(key)) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
      }
    }
    document.body.appendChild(form);
    form.submit();
  }
}



// WEBPACK FOOTER //
// ./src/app/prasad-order/puja-prasad-order/puja-prasad-order.component.ts